import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { HelmetProvider } from 'react-helmet-async';

// Suppress CKEditor warnings
const originalWarn = console.warn;
const originalLog = console.log;

console.warn = (...args: any[]) => {
  const msg = args[0]?.toString?.() || '';
  if (msg.includes('CKEditor') || msg.includes('not secure') || msg.includes('exportpdf')) return;
  originalWarn.apply(console, args);
};

console.log = (...args: any[]) => {
  const msg = args[0]?.toString?.() || '';
  if (msg.includes('CKEditor') && msg.includes('not secure')) return;
  originalLog.apply(console, args);
};

const store = configureStore({ reducer: rootReducer, devTools: true });

const rootElement = document.getElementById('root') as HTMLElement;
const app = (
  <Provider store={store}>
    <React.Fragment>
      <HelmetProvider>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.Fragment>
  </Provider>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();